<div class="{{ isFirstParent ? '' : 'subVersionContainer' }}" *ngFor="let version of versions">
  <h2 id="version-{{ version.number }}" *ngIf="isFirstParent">Version {{ version.number }}</h2>
  <h3 id="version-{{ version.number }}" *ngIf="!isFirstParent">Version {{ version.number }}</h3>
    <ul *ngIf="version.evolutions.length > 0">
      <li *ngFor="let evolution of version.evolutions" [innerHTML]="evolution.details"></li>
    </ul>
  <yo-detailedVersion *ngIf="version.subVersions.length > 0" [versions]="version.subVersions" [isFirstParent]="false"></yo-detailedVersion>
</div>
